import { gql, useMutation } from "@apollo/client"
import { ChangeStatePayload, ChangeStateInput } from "@oysterhr/schema"

export const INVOICING_COMPANY_CHANGE_CREDIT_NOTE_STATE = gql`
  mutation InvoicingCompanyChangeCreditNoteState(
    $creditNoteId: ID!
    $event: InvoicingCreditNoteTransitionEventEnum!
  ) {
    changeStateCreditNote(input: { creditNoteId: $creditNoteId, event: $event }) {
      __typename
    }
  }
`

export const useChangeCreditNoteState = ({ onCompleted }: { onCompleted?: () => void } = {}) =>
  useMutation<{ changeStateCreditNote: Pick<ChangeStatePayload, "__typename"> }, ChangeStateInput>(
    INVOICING_COMPANY_CHANGE_CREDIT_NOTE_STATE,
    {
      onCompleted,
    },
  )
